import React, { useContext } from 'react';
import MessageContextType from './Components/Messages/MessageContextType';
import MessageContext from './Components/Messages/MessageContext';

export interface WithMessagesProps {
  messages: {
    showMessage: MessageContextType['showMessage'];
    setMessages: MessageContextType['setMessages'];
  };
}

function withMessages<T>(Component: React.ComponentType<T & WithMessagesProps>) {
  return (props: Omit<T, keyof WithMessagesProps>) => {
    const context = useContext(MessageContext); // Use MessageContext here

    if (!context) {
      throw new Error('withMessages must be used within a MessageProvider');
    }

    const messages = {
      showMessage: context.showMessage,
      setMessages: context.setMessages,
    };

    // Pass messages prop to the wrapped component
    return <Component {...(props as T)} messages={messages} />;
  };
}

export default withMessages;